/**
 * About Us TOC navigation functions.
 */

const sectionPageNav = document.querySelector('.section-page-nav');
if (sectionPageNav) {
  const panelFixed = document.querySelector('.page-nav');
  const list = document.querySelector('.page-nav__links');
  const navFirst = document.querySelector('#first-link');
  const tocLinks = document.querySelectorAll('.page-nav__link:not(.first-link)');

  let activeSectionId = null;
  let isClickScrolling = false;
  let scrollTimeout = null;

  function getNavHeight() {
    return panelFixed ? panelFixed.offsetHeight : 0;
  }

  function stopClickScrolling() {
    isClickScrolling = false;
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
      scrollTimeout = null;
    }
  }

  /**
   * Dynamic retrieval of content elements (sections), according to the TOC menu.
   */
  const sectionsSelector = Array.from(tocLinks).map(element => {
    const href = element.getAttribute('href');
    return href ? 'section[id="' + href.substring(1) + '"]' : '';
  }).filter(Boolean);

  const sections = sectionsSelector.length ? document.querySelectorAll(sectionsSelector.join(', ')) : [];

  /**
   * Handler for clicking on the first element of the TOC menu (mobile toggle).
   */
  if (navFirst && list) {
    navFirst.addEventListener('click', function (event) {
      event.preventDefault();
      list.classList.toggle('open');
    });
  }

  /**
   * Function to set the active class.
   */
  function setActiveLink(targetId) {
    if (activeSectionId === targetId) return;
    activeSectionId = targetId;

    tocLinks.forEach(link => {
      const href = link.getAttribute('href');
      const isActive = href && href.substring(1) === targetId;
      link.classList.toggle('active-link', isActive);

      if (isActive && navFirst) {
        const span = navFirst.querySelector('span');
        if (span) {
          span.textContent = link.textContent.trim();
        }
      }
    });
  }

  /**
   * Handler for clicks on links in the menu.
   */
  tocLinks.forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      if (list) {
        list.classList.remove('open');
      }

      const href = this.getAttribute('href');
      const targetId = href ? href.substring(1) : '';
      const targetElement = targetId ? document.getElementById(targetId) : null;

      if (targetElement) {
        setActiveLink(targetId);

        isClickScrolling = true;
        if (scrollTimeout) clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(stopClickScrolling, 800);

        const navHeight = getNavHeight();
        const totalOffset = navHeight + 10;
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - totalOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  /**
   * Handler for page scrolling.
   */
  function handleScroll() {
    const navRect = sectionPageNav.getBoundingClientRect();

    if (panelFixed) {
      const isSticky = navRect.top <= 0;
      panelFixed.classList.toggle('scroll-active', isSticky);
    }

    if (isClickScrolling) {
      return;
    }

    let currentSection = null;
    const totalOffset = getNavHeight() + 30;

    sections.forEach(section => {
      const sectionRect = section.getBoundingClientRect();
      if (sectionRect.top <= totalOffset) {
        currentSection = section.getAttribute('id');
      }
    });

    if (currentSection) {
      setActiveLink(currentSection);
    }
  }

  let ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  if ('onscrollend' in window) {
    window.addEventListener('scrollend', stopClickScrolling, { passive: true });
  }
  window.addEventListener('wheel', stopClickScrolling, { passive: true });
  window.addEventListener('touchstart', stopClickScrolling, { passive: true });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', handleScroll, { passive: true });

  handleScroll();
}
